import { createContext } from 'react';

const QueryContext = createContext();

export const QueryProvider = QueryContext.Provider
export default QueryContext